import * as React from 'react';
import styled from 'styled-components';
import { DSGrid, DSTypography } from '../mui';
import { Translate } from '../Translate';
import { MultiImagePickerHelpPopper } from './MultiImagePickerHelpPopper';

const LabelText = styled(DSTypography).attrs({ variant: 'button' })`
    color: ${({ theme }) => theme.palette.success.main};
    font-weight: 400;
    font-size: 1rem;
    padding: 8px;
`;

export function MultiImagePickerNotifier(): JSX.Element {
    return (
        <DSGrid alignItems="center" container justifyContent="space-between" wrap="nowrap">
            <DSGrid alignItems="center" container item justifyContent="flex-end">
                <DSGrid item>
                    <MultiImagePickerHelpPopper />
                </DSGrid>
                <DSGrid item>
                    <LabelText>
                        <Translate keyId="BUILD.MULTI_IMAGE.MULTI_IMAGE_TEMPLATE" />
                    </LabelText>
                </DSGrid>
            </DSGrid>
        </DSGrid>
    );
}
MultiImagePickerNotifier.displayName = 'MultiImagePickerNotifier';
